import { render, staticRenderFns } from "./QueryAnswerMenuItem.vue?vue&type=template&id=c30b2f3a&scoped=true"
import script from "./QueryAnswerMenuItem.vue?vue&type=script&lang=ts"
export * from "./QueryAnswerMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30b2f3a",
  null
  
)

export default component.exports